// C:\Users\server\Desktop\FRONTEND\app-user-front\src\pages\Categories.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Categories() {
  const navigate = useNavigate();

  // 🟢 Scroll to top on page load
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth" if you want animation
    });
  }, []);

  // ✅ Same categories as Home.js
  const browseCategories = [
    {
      key: "Toys & Games",
      label: "TOYS & GAMES",
      image:
        "https://demo.swapiify.com/uploads/products/Early_Years_toys_630_465_int_s_c1.png",
    },
    {
      key: "Sporting Goods",
      label: "SPORTING GOODS",
      image:
        "https://images.pexels.com/photos/47730/the-ball-stadion-football-the-pitch-47730.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    {
      key: "Accessories",
      label: "ACCESSORIES",
      image: "https://demo.swapiify.com/uploads/products/shopping.webp",
    },
    {
      key: "Clothes",
      label: "CLOTHES",
      image:
        "https://images.pexels.com/photos/291762/pexels-photo-291762.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    {
      key: "Books",
      label: "BOOKS",
      image:
        "https://demo.swapiify.com/uploads/products/21%20Books%20on%20Our%20Shelves%20for%20Personal%20and%20Professional%20Development.webp",
    },
    {
      key: "Bags",
      label: "BAGS",
      image:
        "https://demo.swapiify.com/uploads/products/71izkVh7BML._AC_UY1100_.jpg",
    },
    {
      key: "Shoes",
      label: "Shoes",
      image: "https://demo.swapiify.com/uploads/products/shoes.jpg",
    },
  ];

  // ✅ Same click logic as Home.js
  const handleCategoryClick = (categoryKey) => {
    navigate(`/products?category=${encodeURIComponent(categoryKey)}`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Global font import for titles (same as Home) */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700;800&display=swap');
        `}
      </style>

      <div style={styles.container}>
        {/* ✅ Hero Section for Categories */}
        <section style={styles.heroSection}>
          <div style={styles.heroInner}>
            <h1 style={styles.heroTitle}>Discover Categories</h1>
            <p style={styles.heroSubtitle}>
              Browse curated categories and find the perfect items to trade, swap,
              and refresh your lifestyle on Swapiify.
            </p>
            <div style={styles.heroActions}>
              <button
                style={styles.heroButtonPrimary}
                onClick={() => navigate("/products")}
              >
                View All Items →
              </button>
              <button
                style={styles.heroButtonGhost}
                onClick={() => navigate("/")}
              >
                Back to Home
              </button>
            </div>
          </div>
        </section>

        {/* ✅ Category Grid Section (same design as Home) */}
        <section style={styles.browseSection}>
          <div style={styles.sectionContainer}>
            <h2 style={styles.browseTitle}>Trade, Swap & Refresh: Browse Items</h2>

            <div style={styles.browseGrid}>
              {browseCategories.map((cat, index) => (
                <div
                  key={`${cat.key}-${index}`}
                  style={styles.browseCard}
                  onClick={() => handleCategoryClick(cat.key)}
                >
                  <div style={styles.browseImageWrapper}>
                    <img
                      src={cat.image}
                      alt={cat.label}
                      style={styles.browseImage}
                    />
                    <div style={styles.browseLabelWrapper}>
                      <span style={styles.browseLabel}>{cat.label}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.6,
    backgroundColor: "#ffeee7",
    minHeight: "100vh",
  },

  // ✅ Hero section styles
  heroSection: {
    width: "100%",
    padding: "80px 20px 70px",
    background: "#6a2d57",
    color: "#ffffff",
  },
  heroInner: {
    maxWidth: "1200px",
    margin: "0 auto",
    textAlign: "left",
  },
  heroTitle: {
    fontSize: "2.8rem",
    fontWeight: "800",
    color: "#FF7F50",
    marginBottom: "15px",
    fontFamily: "'Poppins', sans-serif",
  },
  heroSubtitle: {
    fontSize: "1.1rem",
    maxWidth: "650px",
    lineHeight: 1.7,
    opacity: 0.96,
    marginBottom: "30px",
  },
  heroActions: {
    display: "flex",
    flexWrap: "wrap",
    gap: "14px",
  },
  heroButtonPrimary: {
    padding: "12px 30px",
    borderRadius: "30px",
    border: "none",
    backgroundColor: "#ffffff",
    color: "#6a2d57",
    fontWeight: 700,
    fontSize: "0.98rem",
    cursor: "pointer",
    boxShadow: "0 8px 22px rgba(0, 0, 0, 0.18)",
  },
  heroButtonGhost: {
    padding: "12px 26px",
    borderRadius: "30px",
    border: "2px solid #ffffff",
    backgroundColor: "transparent",
    color: "#ffffff",
    fontWeight: 600,
    fontSize: "0.95rem",
    cursor: "pointer",
  },

  // Category grid section
  sectionContainer: {
    maxWidth: "1650px",
    margin: "0 auto",
    padding: "0 20px 80px",
  },
  browseSection: {
    backgroundColor: "#ffeee7",
    paddingTop: "60px",
  },
  browseTitle: {
    fontSize: "2rem",
    textAlign: "center",
    marginBottom: "40px",
    color: "#ff7f50",
    fontWeight: "800",
    fontFamily: "'Poppins', sans-serif",
  },
  browseGrid: {
    display: "grid",
    maxWidth: "1300px",
    margin: "auto",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
  },
  browseCard: {
    cursor: "pointer",
  },
  browseImageWrapper: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "0px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
  },
  browseImage: {
    display: "block",
    width: "100%",
    height: "400px",
    objectFit: "cover",
    transition: "transform 0.4s ease",
  },
  browseLabelWrapper: {
    position: "absolute",
    left: "18px",
    bottom: "18px",
    backgroundColor: "#ffffff",
    padding: "10px 18px",
    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.18)",
  },
  browseLabel: {
    fontSize: "0.9rem",
    fontWeight: "700",
    letterSpacing: "0.08em",
    color: "#111",
  },
};
